import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setAccessToken} from "../slices/authSlice";
import {
    getClusters,
    getCluster
} from "../api/client";
import {Header} from "../components/Header";
import {setQueryString} from "../slices/usersSlice";
import {CenteredSpinner} from "../components/CenteredSpinner";
import {HumanDate} from "../components/Helpers";

export const Clusters = () => {

    const urlParams = new URLSearchParams(window.location.search);
    const qsClusterId = urlParams.get('clusterId');
    const showName = urlParams.get('showName') === 'true';
    const dispatch = useDispatch();
    const [clusterList, setClusterList] = useState([]);
    const [selectedClusterId, setSelectedClusterId] = useState(null);
    const [content, setContent] = useState(null);
    const [distances, setDistances] = useState(null);
    const [slideType, setSlideType] = useState(null);
    const [averageDistance, setAverageDistance] = useState(null);
    const [minDistance, setMinDistance] = useState(null);
    const [maxDistance, setMaxDistance] = useState(null);
    
    /*
    const getClusters = () => new Promise((resolve, reject) => {
        return resolve([1,2,3,4,5].map(a=>({id: a, name: `Cluster ${a}`, count: 10})))
    });
    
    const getCluster = (id) => new Promise((resolve, reject) => {
        return resolve([]);
    });*/
    
    useEffect(() => {
        getClusters()
            .then(data => {
                setClusterList(data);
                if(data.filter(a=>a.id?.toString() === qsClusterId).length > 0)
                    setSelectedClusterId(qsClusterId);
                else
                    setSelectedClusterId(data[0].id);
            })
    }, []);

    useEffect(() => {
        if (selectedClusterId === null)
            return;
        setContent(null);
        setDistances(null);
        setSlideType(null);
        setAverageDistance(null);
        setMinDistance(null);
        setMaxDistance(null);
        getCluster(selectedClusterId)
            .then(data => {
                setContent(data.items);
                setDistances(data.distances);
                setSlideType(data.slideType);
                setAverageDistance(data.averageDistance);
                setMinDistance(data.minDistance);
                setMaxDistance(data.maxDistance);
            })
    }, [selectedClusterId]);
    
    const signOut = () => {
        dispatch(setAccessToken(null));
    }
    
    const [selectedPage, setSelectedPage] = useState(null);
    const [highlight1, setHighlight1] = useState(null);
    const [highlight2, setHighlight2] = useState(null);
    
    const setHighlight = (x, y) => {
        setHighlight1(x);
        setHighlight2(y);
    }
    
    const getHealthy = (distance) => {
        if(distance <= 50)
            return "Healthy";
        if(distance <= 60)
            return "Healthy";
        return "Not Healthy";
    }
    
    const getHealthyStyle = (distance) => {
        let health = getHealthy(distance);
        if(distance <= 50)
            return {background: "green", "color": "white"};
        if(distance <= 60)
            return {background: "lightgreen", "color": "black"};
        return {background: "red", "color": "white"};
    }
    
    const getStyle = (distance) => {
        if(distance === 0)
            return {background: "black", "color": "black"};
        if(distance < 15)
            return {background: "green", "color": "white"};
        if(distance < 30)
            return {background: "yellow", "color": "black"};
        if(distance < 50)
            return {background: "orange", "color": "black"};
        if(distance < 100)
            return {background: "red", "color": "white"};
        return {background: "gray", "color": "white"};
    }
    
    return <>
        <Header signOut={signOut} title="Clusters" navigateTo="/Clusters" />
        <div style={{padding: "16px", position: "relative"}}>
            <div style={{position: "absolute", right: 0}}>
                <table style={{fontSize: 4, lineHeight: 1, borderCollapse: "collapse"}}>
                    {distances?.map((d, x) => <tr>{d.map((dist, y)=> x >= y ? <td></td> : <td onMouseOver={()=>setHighlight(x, y)} onMouseOut={()=>setHighlight(null, null)} style={getStyle(dist)}>{dist}</td>)}</tr>)}
                </table>
            </div>
            <div style={{paddingBottom: 16, display: "flex", alignItems: "center", gap: 8}}>
                <div>
                    <select value={selectedClusterId} onChange={(e) => {
                        setQueryString("clusterId", e.target.value);
                        setSelectedClusterId(e.target.value)
                    }
                    }>
                        {clusterList.map(item => (
                            <option key={item.id} value={item.id}>
                                Cluster {showName? item.name : item.id} ({item.total} slides)
                            </option>
                        ))}
                    </select>
                </div>
                {slideType && <h3>
                    {slideType} {averageDistance && <span style={getHealthyStyle(averageDistance)}>{getHealthy(averageDistance)}</span>}
                </h3>}
            </div>
            {(content === null) && <CenteredSpinner />}
            {content && <div style={{display: "flex", flexWrap: "wrap", gap: 8}}>
                {content.map((page, i)=> 
                    <div style={{display: "flex", flexDirection: "column", border: `${i === highlight1 ? "1px solid blue" : i === highlight2 ? "1px solid purple" : "1px solid #cfd4da"}`, borderRadius: 4, padding: "8px"}}>
                        <div style={{display: "flex", alignItems: "center", gap: "12px"}}>
                            <img onClick={()=>setSelectedPage(page)} style={{cursor: "pointer"}} width={192*2} height={108*2} loading="lazy" src={page.smallMediumThumbnailUrl} alt={page.name}/>
                        </div>
                        <div style={{textAlign: "center"}}>
                            {page.pageHashes.length.toLocaleString()}
                        </div>
                    </div>
                )}
            </div>}
        </div>
    </>;
}